<template>
	<div>
		<a-modal
		      :title="form.rule_id > 0 ? '编辑规则' : '新增规则'"
		      :visible="visible"
		      :confirm-loading="confirmLoading"
		      @ok="handleOk"
		      @cancel="handleCancel"
			  width="850px"
		    >
		    <a-form-model :model="form">

		      	<a-form-model-item required label="规则名称">
		      		<a-input v-model="form.name" placeholder="输入规则名称" style="width: 300px;"></a-input>
		      	</a-form-model-item>

		      	<a-form-model-item required label="折扣">
					<a-input-number
						v-model="form.discount"
						:min="0"
						:max="0.99"
						:precision="2"
						:step="0.01"
						placeholder="输入折扣（0~0.99）"
						style="width: 300px;"
					/>
		      	</a-form-model-item>

				<!-- <a-form-model-item required label="所属门店">
					<a-select style="width: 200px;" v-model="form.mendian_id">
						<a-select-option :value="0">请选择</a-select-option>
						<a-select-option v-for="(item,index) in mendians" :key="index" :value="item.mendian_id">{{item.name}}</a-select-option>
					</a-select>
				</a-form-model-item> -->

				<a-form-model-item label="规则简介">
					<a-input v-model="form.info"  placeholder="输入规则简介" type="textarea"></a-input>
				</a-form-model-item>

				<a-form-model-item label="状态">
					<a-radio-group v-model="form.status">
						<a-radio :value="1">正常</a-radio>
						<a-radio :value="2">失效</a-radio>
					</a-radio-group>
				</a-form-model-item>

				<a-form-model-item label="项目配置">
					<div style="color:red;">现价只有设置 > 0 才生效</div>
					<div class="mt20">
						<table class="wxb-table list" style="width: 800px;">
							<thead>
								<th>项目</th>
								<th>资深原价</th>
								<th>总监原价</th>
								<th>专家原价</th>
								<th>资深现价</th>
								<th>总监现价</th>
								<th>专家现价</th>
								<!-- <th>操作</th> -->
							</thead>
							<tbody>
								<tr v-for="(item,index) in project_setting.data">
									<td>
										{{item.abbreviation}}
									</td>
									<td>
										{{item.market_price}}元
									</td>
									<td>
										{{item.expert_price}}元
									</td>
									<td>
										{{item.master_price}}元
									</td>
									<td>
										<a-input-number v-model="item.market_price_r"  :formatter="value => `${value}元`" placeholder="请输入" :precision="2" :min="0" style="width: 80px;"/>
									</td>
									<td>
										<a-input-number v-model="item.expert_price_r"  :formatter="value => `${value}元`" placeholder="请输入" :precision="2" :min="0" style="width: 80px;"/>
									</td>
									<td>
										<a-input-number v-model="item.master_price_r"  :formatter="value => `${value}元`" placeholder="请输入" :precision="2" :min="0" style="width: 80px;"/>
									</td>

									<!-- <td class="clickAct" @click="delDividendRatioData(index)">
										<i class="iconfont iconbtn_close"/>
									</td> -->
								</tr>
							</tbody>
						</table>
						<!-- <div class="mt10">
							<a-button type="primary" icon="plus" ghost @click="addDividendRatioData()">添加</a-button>
						</div> -->
					</div>
				</a-form-model-item>
		      	
		    </a-form-model>	
		</a-modal>
	</div>
</template>

<script>
	import uploadImg from '../../../../components/upload/upload.vue';
	import BaiduMap from '../../../../components/map/baidumap.vue';
	export default {
		components:{
			uploadImg,
			BaiduMap
		},
		props:{
			datas:{
				type:Object,
				default:function(){
					return new Object;
				}
			},
		},
		data(){
			return {
				confirmLoading:false,
				visible:true,
				form:{},
				mendians:[],
				project_setting:{
					data:[],
					is_bind_shareholder:0,
				},
			}
		},
		created(){
			this.form = JSON.parse(JSON.stringify(this.datas));
			this.visible = true;
			this.getMendians();
			this.getProjects();
		},
		methods:{
			getMendians(){
				this.$http.api('admin/getAllMendian').then(res=>{
					this.mendians = res.mendian;
				}).catch(res=>{
					console.log(res);
				});
			},
			getProjects(){
				// 获取所有项目
				this.$http.api('admin/getAllRuleProject',{
					rule_id:this.form.rule_id,
				}).then(res=>{
					this.project_setting.data = res.project;
				}).catch(res=>{
					console.log(res);
				});
			},
			selectAct(res){
				this.form.lng = res.lng;
				this.form.lat = res.lat;
			},
			handleOk(){
				if(this.confirmLoading == true) return;
				this.confirmLoading = true;
				this.$http.api('admin/saveDiscountRule',{
					rule_id:this.form.rule_id,
					name:this.form.name,
					discount	:this.form.discount,
					mendian_id	:this.form.mendian_id,
					info	:this.form.info,
					status	:this.form.status,
					data:JSON.stringify(this.project_setting.data),
				}).then(res=>{
					this.$message.success('操作成功');
					this.confirmLoading = false;
					this.visible = false;
					this.$emit('ok');
				}).catch(res=>{
					this.confirmLoading=false;
				})
			},
			handleCancel(){
				this.visible = false;
				this.$emit('closed');
			},
			addDividendRatioData(){
				let data=this.project_setting.data;
				let length = data.length;
				/*this.project_setting.data.push({
					market_price_r:length==0 ? 0 : data[length-1].market_price_r,
					project_id:0,
				})*/
			},
			delDividendRatioData(index){
				// this.project_setting.data.splice(index,1);
			},
		}
	}
</script>

<style>
	
</style>